import mutations from './employabilitySicknessNonValidatedDocuments.mutations'
import actions from './employabilitySicknessNonValidatedDocuments.actions'
import getters from './employabilitySicknessNonValidatedDocuments.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
